var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 196,
    viewBox: "0 0 224 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4944_54218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.46 193.752C119.805 193.693 121.146 193.615 122.478 193.521L120.03 149.412L135.235 192.04C136.551 191.828 137.859 191.598 139.159 191.349L127.866 148.021L151.473 188.398C152.728 188.034 153.978 187.66 155.212 187.262L135.333 145.736L166.788 182.914C167.957 182.409 169.109 181.886 170.249 181.351L142.251 142.617L180.816 175.714C181.87 175.079 182.903 174.432 183.924 173.772L148.459 138.729L193.244 166.98C194.159 166.233 195.057 165.476 195.93 164.704L153.814 134.169L203.795 156.92C204.545 156.079 205.275 155.223 205.985 154.358L158.189 129.043L212.197 145.745C212.771 144.827 213.32 143.899 213.849 142.966L161.478 123.468L218.249 133.724C218.63 132.753 218.991 131.776 219.327 130.789L163.61 117.579L221.8 121.137C221.976 120.134 222.136 119.126 222.268 118.111L164.533 111.509L222.78 108.281C222.755 107.263 222.714 106.246 222.641 105.237L164.221 105.405L221.193 95.457C220.968 94.4548 220.718 93.4587 220.443 92.4689L162.688 99.4101L217.048 82.9566C216.621 81.9948 216.166 81.0423 215.694 80.0961L159.973 93.6579L210.401 71.0942C209.786 70.1947 209.146 69.3045 208.49 68.4236L156.127 88.2917L201.441 60.1408C200.654 59.3221 199.85 58.516 199.022 57.7191L151.251 83.4297L190.39 50.3421C189.447 49.6262 188.484 48.9258 187.508 48.2379L145.453 79.1934L177.494 41.9441C176.42 41.3465 175.334 40.7582 174.23 40.1886L138.872 75.6792L163.061 35.1274C161.88 34.6605 160.687 34.2123 159.481 33.7765L131.655 72.9681L147.417 30.0724C146.159 29.7518 144.887 29.4499 143.608 29.1604L123.987 71.1285L130.934 26.91C129.626 26.7388 128.309 26.5863 126.985 26.4493L116.032 70.1947L114.007 25.7023C113.343 25.6929 112.678 25.6836 112.01 25.6836C111.342 25.6836 110.677 25.6929 110.013 25.7023L107.987 70.1947L97.035 26.4524C95.7105 26.5894 94.3943 26.7419 93.0862 26.9131L100.032 71.1285L80.4116 29.1604C79.1323 29.4499 77.8611 29.7487 76.6023 30.0724L92.3604 72.9712L64.5346 33.7796C63.3291 34.2154 62.1358 34.6636 60.9549 35.1305L85.1436 75.6823L49.7893 40.1917C48.6863 40.7613 47.5997 41.3465 46.5253 41.9473L78.5664 79.1965L36.512 48.2411C35.5361 48.9321 34.5724 49.6293 33.6293 50.3452L72.7684 83.4328L24.9978 57.7222C24.1695 58.516 23.3659 59.3253 22.5786 60.1439L67.8929 88.2948L15.5257 68.4205C14.8697 69.3013 14.23 70.1916 13.6149 71.0911L64.0426 93.6548L8.32121 80.0961C7.84966 81.0423 7.39451 81.9948 6.96806 82.9566L61.3198 99.4039L3.56877 92.4658C3.29403 93.4556 3.04801 94.4517 2.81838 95.4539L59.7904 105.402L1.37501 105.237C1.3053 106.246 1.2602 107.263 1.2356 108.281L59.4828 111.509L1.74815 118.108C1.87937 119.123 2.03929 120.131 2.21561 121.133L60.4054 117.576L4.6923 130.786C5.02443 131.772 5.38938 132.75 5.77072 133.721L62.5418 123.465L10.1664 142.966C10.6954 143.903 11.249 144.827 11.8189 145.745L65.8263 129.043L18.0352 154.358C18.7487 155.22 19.4745 156.076 20.2249 156.92L70.2056 134.169L28.0896 164.708C28.9671 165.48 29.8651 166.236 30.7754 166.983L75.5608 138.732L40.0958 173.772C41.1168 174.435 42.1501 175.082 43.2039 175.714L81.7689 142.614L53.7709 181.348C54.9108 181.883 56.063 182.406 57.2317 182.91L88.6864 145.733L68.8073 187.259C70.0415 187.657 71.2881 188.031 72.5469 188.395L96.1534 148.017L84.8607 191.346C86.1605 191.595 87.4686 191.825 88.7848 192.037L103.989 149.409L101.541 193.518C102.874 193.612 104.215 193.69 105.56 193.749L112.01 149.879L118.46 193.752Z",
    fill: "url(#paint0_radial_4944_54218)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4944_54218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8646 26.2192L51.2271 28.2532L55.1556 28.1517L53.1216 31.5142L53.2231 35.4426L49.8606 33.4087L45.9321 33.5101L47.9661 30.1477L47.8646 26.2192Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5995 28.157L83.6555 30.0282L86.3962 30.4944L84.5251 32.5504L84.0588 35.2911L82.0028 33.42L79.2621 32.9537L81.1333 30.8977L81.5995 28.157Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7764 0.472656L101.662 3.92047L105.11 5.80614L101.662 7.6918L99.7764 11.1396L97.8907 7.6918L94.4429 5.80614L97.8907 3.92047L99.7764 0.472656Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.675 23.4492L129.561 26.897L133.009 28.7827L129.561 30.6684L127.675 34.1162L125.789 30.6684L122.342 28.7827L125.789 26.897L127.675 23.4492Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.281 18.5377L153.412 21.5578L155.151 24.0302L152.131 24.1608L149.659 25.9002L149.528 22.8802L147.789 20.4078L150.809 20.2771L153.281 18.5377Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.443 26.1432L172.743 28.2767L176.673 28.2925L174.54 31.5927L174.524 35.5225L171.224 33.389L167.294 33.3732L169.427 30.073L169.443 26.1432Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1089 63.0927L24.3356 62.8246L26.9077 60.8581L27.1758 64.0847L29.1423 66.6568L25.9157 66.9249L23.3436 68.8914L23.0755 65.6648L21.1089 63.0927Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2624 42.7266L65.1481 46.1744L68.5959 48.06L65.1481 49.9457L63.2624 53.3935L61.3768 49.9457L57.929 48.06L61.3768 46.1744L63.2624 42.7266Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6712 41.3521L98.5278 44.0508L102.389 44.7818L99.6903 47.6385L98.9592 51.4996L96.1026 48.801L92.2414 48.0699L94.9401 45.2133L95.6712 41.3521Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.162 50.5273L132.395 52.7817L134.649 54.0146L132.395 55.2476L131.162 57.5019L129.929 55.2476L127.675 54.0146L129.929 52.7817L131.162 50.5273Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7722 162.852L52.6145 160.138L53.5435 156.32L56.2573 159.162L60.0757 160.091L57.2334 162.805L56.3043 166.624L53.5906 163.781L49.7722 162.852Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.847 136.339L153.706 134.564L154.313 132.068L156.088 133.926L158.584 134.533L156.726 136.308L156.118 138.804L154.344 136.946L151.847 136.339Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.834 36.8367L152.804 40.7664L154.899 44.0911L150.969 44.0614L147.645 46.1565L147.674 42.2268L145.579 38.9021L149.509 38.9318L152.834 36.8367Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.861 48.2869L189.659 51.0471L193.503 51.8619L190.743 54.6592L189.928 58.5035L187.131 55.7434L183.287 54.9286L186.047 52.1313L186.861 48.2869Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8665 101.412L38.2487 105.323L40.6806 108.41L36.7694 108.793L33.6825 111.224L33.3003 107.313L30.8684 104.226L34.7796 103.844L37.8665 101.412Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.484 139.168L29.682 142.426L33.2903 143.983L30.0327 146.181L28.4758 149.789L26.2777 146.531L22.6695 144.974L25.927 142.776L27.484 139.168Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4551 125.741L44.8178 127.09L47.5349 126.951L46.1861 129.313L46.3251 132.03L43.9623 130.682L41.2453 130.821L42.5941 128.458L42.4551 125.741Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.319 151.905L164.682 153.254L167.399 153.115L166.05 155.477L166.189 158.194L163.826 156.846L161.109 156.985L162.458 154.622L162.319 151.905Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.686 139.581L190.052 143.493L192.472 146.59L188.559 146.956L185.462 149.376L185.096 145.463L182.677 142.366L186.589 142L189.686 139.581Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.813 81.7077L183.332 84.1446L185.926 85.3769L183.489 86.8961L182.257 89.4901L180.738 87.0531L178.144 85.8209L180.581 84.3016L181.813 81.7077Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4721 153.325L83.5389 151.41L80.8785 150.841L82.7929 148.908L83.3618 146.248L85.2949 148.162L87.9554 148.731L86.041 150.664L85.4721 153.325Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3025 74.0949L75.9613 70.2207L74.4258 66.6033L78.3 67.2621L81.9174 65.7267L81.2586 69.6008L82.794 73.2182L78.9199 72.5594L75.3025 74.0949Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7022 101.305L63.8654 98.5579L61.6788 96.6962L64.4259 95.8595L66.2875 93.6728L67.1243 96.42L69.311 98.2816L66.5638 99.1183L64.7022 101.305Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8872 133.641L65.3103 131.747L63.8026 130.463L65.6967 129.886L66.9802 128.379L67.5572 130.273L69.0648 131.556L67.1707 132.133L65.8872 133.641Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.561 80.9261L156.984 79.032L155.476 77.7485L157.37 77.1716L158.654 75.6639L159.231 77.558L160.738 78.8416L158.844 79.4185L157.561 80.9261Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.565 81.6918L211.988 79.7977L210.48 78.5141L212.374 77.9372L213.658 76.4296L214.235 78.3236L215.743 79.6072L213.848 80.1841L212.565 81.6918Z",
    fill: "#FFFBBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.158 102.388L193.849 105.252L197.66 106.212L194.796 108.902L193.836 112.713L191.145 109.849L187.334 108.889L190.198 106.199L191.158 102.388Z",
    fill: "#FFFBBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4944_54218",
    x: 0.756474,
    y: 25.2045,
    width: 222.503,
    height: 169.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.239561,
    result: "effect1_foregroundBlur_4944_54218"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4944_54218",
    x: 19.1924,
    y: 0.472656,
    width: 198.467,
    height: 169.985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.91648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.958242
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4944_54218"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4944_54218",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4944_54218",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.008 109.718) rotate(90) scale(84.0341 110.772)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteStars);
export default __webpack_public_path__ + "static/media/white-stars.279af04695ada8c3f6dfe3a950acd534.svg";
export { ForwardRef as ReactComponent };